import { EApplicantType, EFinancingProgram } from '@if/core/types'
import { useDialog } from '@if/mui'
import { Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'
import FlinksOptionBox from './FlinksOptionBox'
import ManualOptionBox from './ManualOptionBox'

interface Params {
  applicantType: EApplicantType
  creditApplicationId: string
  canSkipFlinks: boolean
  financingProgramId: EFinancingProgram
}

/**
 * The "what's Flinks?" income-verification procedure dialog — the Flinks + manual
 * option boxes side by side. Opened imperatively via the returned handle's
 * `open()`; a single "Close" action (no confirm).
 */
export const useBankAccountProcedureDialog = ({
  applicantType,
  creditApplicationId,
  canSkipFlinks,
  financingProgramId,
}: Params) => {
  const { t } = useTranslation()
  return useDialog({
    title: t('incomeVerification.bankAccountProcedure.whatsFlinks'),
    maxWidth: 'lg',
    hideConfirm: true,
    // Two columns from `md` up, stacked below — a row of cards could only squeeze,
    // never wrap, which crushed both boxes on a laptop-width dialog.
    content: () => (
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: canSkipFlinks ? 6 : 12 }}>
          <FlinksOptionBox canSkipFlinks={canSkipFlinks} />
        </Grid>
        {canSkipFlinks && (
          <Grid size={{ xs: 12, md: 6 }}>
            <ManualOptionBox
              financingProgramId={financingProgramId}
              creditApplicationId={creditApplicationId}
              applicantType={applicantType}
            />
          </Grid>
        )}
      </Grid>
    ),
  })
}
